module.exports = __webpack_public_path__ + "static/media/genuine-background-VI.5e5fad82.png";